export default __webpack_public_path__ + "static/media/MaternalHolidayIcon.378adb2b.svg";